import { type ProviderStatus } from '@/karehero-app/care/shortlists/fixtures';

/** The shortlists, as the Care hub opens them. */
export const HUB_SHORTLISTS = {
  list: {
    title: 'Shortlists',
    count: (n: number, updated: string) => `${n} picked, updated ${updated}`,
    waiting: 'Waiting to hear about space',
    call: 'Questions about these? A care expert can talk them through.',
    none: (name: string) =>
      `No shortlists for ${name} yet. A care expert can make one with you.`,
  },
  shortlist: {
    waiting:
      "Your care expert has asked who has space. They'll show here once they reply.",
  },
  provider: {
    from: (price: string) => `From ${price}`,
    note: 'From your care expert',
    facts: {
      rating: 'Inspection rating',
      price: 'Price',
      space: 'Space',
      visiting: 'Visiting',
    },
    care: 'Types of care',
    visit: 'Book a visit',
    call: (phone: string) => `Call ${phone}`,
    email: 'Email them',
  },
  /** The status in plain words. Not contacted says nothing yet. */
  status: {
    'Not contacted': undefined,
    Contacted: 'Asked about space',
    // Not said in the hub: there's no choosing a home here.
    Secured: undefined,
    Available: 'Has space',
    Unavailable: 'No space',
  } as Record<ProviderStatus, string | undefined>,
};

/** "Updated 28th May" as the hub writes dates: "28 May". */
export const hubDate = (updated: string) =>
  updated.replace(/^Updated /, '').replace(/(\d+)(st|nd|rd|th)/, '$1');

/** "£1,250/week" as "£1,250 a week". */
export const hubPrice = (price: string) => price.replace('/', ' a ');
